import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class StringInterceptor implements HttpInterceptor{
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (typeof request.body === 'string') {     
        const contentType = request.headers.get('Content-Type')
        if (contentType == 'application/json' || contentType == 'text/json') {
            request = request.clone({
                body: JSON.stringify(request.body)
            });
        }
    }

    return next.handle(request)
  }
}
